module.exports = __webpack_public_path__ + "img/bus-fill-darkblue.ae8bc03b.svg";